import * as React from 'react'
import '../common/bootstrap/installAngularModules'
import {remount, unmount} from "../common/bootstrap/reactAngularGlue";
import * as PropTypes from 'prop-types'

// promise that resolves when the page / scripts are fully loaded
const onceLoaded = new Promise((res) => {
  if (document.readyState === 'complete') {
    res()
  } else {
    window.addEventListener("load", () => res());
  }
})


let active;
angular.module('clientDashboardApp').factory('reactContainer', () => ({
  getContainer() {
    return active
  }
}));



/**
 * wraps the client dashboard app component so that it can be mounted/unmounted via react
 **/
export default class ClientDashboardApp extends React.Component {
  container;
  ngApp;

  static propTypes = {
    reactContainer: PropTypes.any,
    propogateGroupIdToUIRouter: PropTypes.bool,
    useGlueDirective: PropTypes.bool
  }

  static defaultProps = {
    propogateGroupIdToUIRouter: true
  }

  componentDidMount() {
    if (this.props.reactContainer) {
      active = this.props.reactContainer
    }
    // can throw a fit about templates not being loaded yet. Wait for page load event
    onceLoaded.then(() => {
      remount({hackGroupId: this.props.propogateGroupIdToUIRouter})
      this.ngApp = angular.bootstrap(this.container, ['clientDashboardApp']);
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!_.isEqual(this.props.uiRouterState, prevProps.uiRouterState)) {
      console.warn("detected attempt to modify <ClientDashboardApp /> uiRouterState prop. This is not supported and should not be mutated. ")
    }
  }

  componentWillUnmount() {
    if (active === this.props.reactContainer) {
      active = undefined
    }
    unmount()
  }

  setContainer = (element) => {
    return this.container = element
  };

  html = {
    __html:
      this.props.useGlueDirective
      ? `<div ng-controller="RootController" ui-router-state-glue></div>`
      : `<div ng-controller="RootController" ui-view></div>`
  }

  render = () => {
    return <div
      ref={this.setContainer}
      dangerouslySetInnerHTML={this.html}
    />

  }


}

let activeGlue;
angular.module('clientDashboardApp').factory('glueContainer', () => ({
  getContainer() {
    return activeGlue;
  }
}))

export class ReactUIRouterView extends React.Component {
  static propTypes = {
    // specify a ui-router like configuration object.
    // will render the template with the specified controller, but without ui-router getting its grabby hands all
    // over the url (so that we can stop using ui-router for routing and query parameters)
    state: PropTypes.shape({
      controller: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
      controllerAs: PropTypes.string,
      template: PropTypes.string
    }).isRequired,
    reactContainer: PropTypes.any
  }
  componentDidMount() {
    activeGlue = this;
  }

  componentWillUnmount() {
    if (activeGlue === this) {
      activeGlue = undefined;
    }
  }

  render() {
    return <ClientDashboardApp
      reactContainer={this.props.reactContainer}
      useGlueDirective
      propogateGroupIdToUIRouter={false}
    />
  }
}


